import { environment } from '../../environments/environment';

/**
 * Helpers de montagem de URL para imagens do Item.
 * Subdiretorio canonico das secundarias: `item_imagem` (com underscore).
 */

/**
 * Monta a URL completa da imagem PRINCIPAL do item.
 * - Passthrough para URLs absolutas (http/https) e data URLs.
 * - Caso contrario, monta `${imgHost}/${idEmpresa}/item/${nome}`.
 */
export function getImagemPrincipalDoItem(
  idEmpresa: string,
  nome: string | undefined | null,
): string {
  if (!nome) return '';
  if (nome.startsWith('http://') || nome.startsWith('https://')) return nome;
  if (nome.startsWith('data:image')) return nome;
  return `${environment.imgHost}/${idEmpresa}/item/${nome}`;
}

/**
 * Monta a URL completa de uma imagem SECUNDARIA do item.
 * - Passthrough para URLs absolutas (http/https) e data URLs.
 * - Caso contrario, monta `${imgHost}/${idEmpresa}/item_imagem/${nome}`.
 */
export function getImagemSecundariaDoItem(
  idEmpresa: string,
  nome: string | undefined | null,
): string {
  if (!nome) return '';
  if (nome.startsWith('http://') || nome.startsWith('https://')) return nome;
  if (nome.startsWith('data:image')) return nome;
  return `${environment.imgHost}/${idEmpresa}/item_imagem/${nome}`;
}
